import { createContext } from 'react';

export interface SidebarContextType {
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (isCollapsed: boolean) => void;
  expandedSections: Record<string, boolean>;
  toggleSection: (sectionTitle: string) => void;
}

const SidebarContext = createContext<SidebarContextType | null>(null);
export default SidebarContext;
